import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    setting: {
        url: `${customerApi}/api/mass_sending_config`,
        type: 'GET',
    },
    enableSetting: {
        url: `${customerApi}/api/mass_sending_config`,
        type: 'PUT',
    },
    updateSetting: {
        url: `${customerApi}/api/mass_sending_config/{message_type}`,
        type: 'PUT',
    },
}
